import React from 'react'
import Layout from '../components/layout'

const ContactPage = () => {
  return (
    <Layout>
      <main className="py-10">
        <div className="contain">
          <h2 className="heading fz-xl">Contact page</h2>
        </div>
      </main>
    </Layout>
  )
}

export default ContactPage
